import { Options } from '../Options'

export const descriptorOptions = Options.asRecord(
  Options.createOption({
    key: 'label',
    inputKind: 'text',
    label: 'Label',
    description: 'Display label for a value, series, axis, or annotation.',
    category: 'Descriptor',
  }),
  Options.createOption({
    key: 'title',
    inputKind: 'text',
    label: 'Title',
    description: 'Descriptor title text.',
    category: 'Descriptor',
  }),
  Options.createOption({
    key: 'subtitle',
    inputKind: 'text',
    label: 'Subtitle',
    description: 'Descriptor subtitle text.',
    category: 'Descriptor',
  }),
  Options.createOption({
    key: 'description',
    inputKind: 'text',
    label: 'Description',
    description: 'Descriptor description text.',
    category: 'Descriptor',
  }),
)

export type DescriptorOptions = Options.TypeOf<typeof descriptorOptions>
